// extracted by mini-css-extract-plugin
export default {"tab_menu_container":"tab_tab_menu_container__susmK","tab_menu":"tab_tab_menu__3eera","tab_menu_item":"tab_tab_menu_item__GqYiO","active":"tab_active__Gh6us"};